'use strict';
import React, { PureComponent } from 'react';
import TablaHeader from './Tabla/TablaHeader'
import TablaBody from './Tabla/TablaBody'

class Tabla extends PureComponent {

    constructor(props) {
        super(props);

    }

    render() {
        const { getCodigo, ingresoAjuste, ajustes, confirmarAjuste, denegarAjuste, editar, eliminarAjuste, expandirRow, rowSeleccionada, permisosUsuario, siNoConfirmacion } = this.props;
        // https://bancar.atlassian.net/browse/ADT-1767 - item 9
        // si es cuenta prepaga dirá "Ajustes/Cargos registrados en el transcurso del mes"
        // para cuentas de tarjeta de crédito deberá indicar "Ajustes/Cargos registrados desde el último cierre".
        let tituloGrilla = true ? "Ajustes/Cargos registrados en el transcurso del mes" : "Ajustes/Cargos registrados desde el último cierre";
        let classScroll = ajustes.length > 5 ? ' ingresoAjustesScroll' : '';
        let tieneScroll = classScroll ? true : false;

        return (
            <div className="row top-separator-xs">

                <div className="col-xs-12" style={{width: "70em"}}>

                    <h3>{tituloGrilla}</h3>

                    <table className="ingresoAjustesTableWidth noBorder ingresoAjustesTableHeaderMain">
                        <TablaHeader tieneScroll={tieneScroll} />
                    </table>
                    <table className={"ingresoAjustesTableWidth noBorder"}>
                        <TablaBody ingresoAjuste={ingresoAjuste}
                            ajustes={ajustes}
                            expandirRow={expandirRow}
                            rowSeleccionada={rowSeleccionada}
                            getCodigo={getCodigo}
                            confirmarAjuste={confirmarAjuste}
                            denegarAjuste={denegarAjuste}
                            editar={editar}
                            eliminarAjuste={eliminarAjuste}
                            permisosUsuario={permisosUsuario}
                            siNoConfirmacion={siNoConfirmacion}
                            classScroll={classScroll}
                        />
                    </table>

                </div>
            </div>
        )

    }
}

export default Tabla;